// Styles
// Import Flag Icons Set
import 'flag-icon-css/css/flag-icon.min.css';
// Import Font Awesome Icons Set
import 'font-awesome/css/font-awesome.min.css';
// Import Simple Line Icons Set
import 'simple-line-icons/css/simple-line-icons.css';

import React from 'react';
import ReactDOM from 'react-dom';
import { HashRouter, Route, Switch } from 'react-router-dom';
import { Provider } from 'react-redux';

import store from './store';

// Import Main styles for this application
import '../scss/style.scss';
// Temp fix for reactstrap
import '../scss/core/_dropdown-menu-right.scss';

// Containers
import LanguageProvider from './containers/LanguageProvider/';
import Full from './containers/_Full';

// const history = syncHistoryWithStore(browserHistory, store);
// Views
import Login from './views/Pages/_Login';
import Forgot from './views/Pages/_Forgot';
import Register from './views/Pages/_Register';
import Confirmation from './views/Pages/_Confirmation';
import Interviewed from './views/Pages/_Interviewed';
import Signed from './views/Pages/_Signed';
import Page404 from './views/Pages/Page404/';
import Page500 from './views/Pages/Page500/';

ReactDOM.render(
  <Provider store={store}>
    <LanguageProvider>
      <HashRouter>
        <Switch>
          <Route exact path="/login" name="Login Page" component={Login} />
          <Route
            exact
            path="/forgot_password"
            name="Forgot Password"
            component={Forgot}
          />
          <Route
            exact
            path="/register"
            name="Registration"
            component={Register}
          />
          <Route
            path="/confirmation/:confirmation_token"
            name="Confirmation"
            component={Confirmation}
          />
          <Route
            path="/interviewed/:interviewed_token"
            name="Interviewed"
            component={Interviewed}
          />
          <Route
            path="/signed/:signed_token"
            name="Signed"
            component={Signed}
          />
          <Route exact path="/404" name="Page 404" component={Page404} />
          <Route exact path="/500" name="Page 500" component={Page500} />
          <Route path="/" name="Trainings" component={Full} />
        </Switch>
      </HashRouter>
    </LanguageProvider>
  </Provider>,
  document.getElementById('root'),
);



// WEBPACK FOOTER //
// ./src/index.js